import { render } from "./editor-control.vue?vue&type=template&id=6cf119b6&scoped=true&ts=true"
import script from "./editor-control.vue?vue&type=script&lang=ts"
export * from "./editor-control.vue?vue&type=script&lang=ts"

import "./editor-control.vue?vue&type=style&index=0&id=6cf119b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf119b6"]])

export default __exports__